/**
 * @generated SignedSource<<282fb091850f14cb6d6e14bd25947f5b>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": 10,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "month"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v2 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v3 = {
        "kind": "Variable",
        "name": "model",
        "variableName": "model"
    }, v4 = {
        "kind": "Variable",
        "name": "month",
        "variableName": "month"
    }, v5 = [
        (v1 /*: any*/),
        (v2 /*: any*/),
        (v3 /*: any*/)
    ], v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v7 = [
        (v6 /*: any*/)
    ], v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v9 = [
        {
            "kind": "Literal",
            "name": "unit",
            "value": "HOUR"
        }
    ], v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unit",
        "storageKey": null
    }, v12 = [
        (v10 /*: any*/),
        (v11 /*: any*/)
    ], v13 = [
        (v6 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
        }
    ], v14 = [
        (v6 /*: any*/),
        (v8 /*: any*/)
    ], v15 = {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": (v14 /*: any*/),
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "RunningSchedulesInformationByMonth_fragmentQuery",
            "selections": [
                {
                    "args": [
                        (v1 /*: any*/),
                        (v2 /*: any*/),
                        (v3 /*: any*/),
                        (v4 /*: any*/)
                    ],
                    "kind": "FragmentSpread",
                    "name": "RunningSchedulesInformationByMonth_fragment"
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "RunningSchedulesInformationByMonth_fragmentQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v5 /*: any*/),
                    "concreteType": "SchedulableEntityConnection",
                    "kind": "LinkedField",
                    "name": "schedulableEntities",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "SchedulableEntityEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__typename",
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": (v7 /*: any*/),
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v6 /*: any*/),
                                                (v8 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "color",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": [
                                                        (v4 /*: any*/)
                                                    ],
                                                    "concreteType": "ScheduleTimesByMonthPayload",
                                                    "kind": "LinkedField",
                                                    "name": "scheduleTimesByMonth",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TimeReport",
                                                            "kind": "LinkedField",
                                                            "name": "timeReport",
                                                            "plural": false,
                                                            "selections": (v7 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleTimesByMonthSummary",
                                                            "kind": "LinkedField",
                                                            "name": "summary",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": (v9 /*: any*/),
                                                                    "concreteType": "TimeSpanUnitValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "totalTime",
                                                                    "plural": false,
                                                                    "selections": (v12 /*: any*/),
                                                                    "storageKey": "totalTime(unit:\"HOUR\")"
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": (v9 /*: any*/),
                                                                    "concreteType": "TimeSpanUnitValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "workedTime",
                                                                    "plural": false,
                                                                    "selections": (v12 /*: any*/),
                                                                    "storageKey": "workedTime(unit:\"HOUR\")"
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": (v9 /*: any*/),
                                                                    "concreteType": "TimeSpanUnitValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "absenceTime",
                                                                    "plural": false,
                                                                    "selections": (v12 /*: any*/),
                                                                    "storageKey": "absenceTime(unit:\"HOUR\")"
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TimeSummaryByEmployment",
                                                            "kind": "LinkedField",
                                                            "name": "employmentSummaries",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Employment",
                                                                    "kind": "LinkedField",
                                                                    "name": "employment",
                                                                    "plural": false,
                                                                    "selections": (v13 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "TimeReportSummaryByEmployment",
                                                                    "kind": "LinkedField",
                                                                    "name": "timeReportSummary",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": (v9 /*: any*/),
                                                                            "concreteType": "TimeSpanUnitValue",
                                                                            "kind": "LinkedField",
                                                                            "name": "expectedWorkTime",
                                                                            "plural": false,
                                                                            "selections": (v12 /*: any*/),
                                                                            "storageKey": "expectedWorkTime(unit:\"HOUR\")"
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TimeReportSummaryByEmploymentAndEvent",
                                                                            "kind": "LinkedField",
                                                                            "name": "eventSummaries",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v15 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isWork",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "TimeReportSummaryByEmploymentAndEventPartsSummary",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "nonRegularPartsSummary",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        (v15 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": [
                                                                                                {
                                                                                                    "kind": "Literal",
                                                                                                    "name": "unit",
                                                                                                    "value": "SECOND"
                                                                                                }
                                                                                            ],
                                                                                            "concreteType": "TimeSpanUnitValue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "duration",
                                                                                            "plural": false,
                                                                                            "selections": (v12 /*: any*/),
                                                                                            "storageKey": "duration(unit:\"SECOND\")"
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v11 /*: any*/),
                                                                                (v10 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CompensatoryTimesByTimeStore",
                                                            "kind": "LinkedField",
                                                            "name": "compensatoryTimes",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "EmploymentSetting",
                                                                    "kind": "LinkedField",
                                                                    "name": "employmentSetting",
                                                                    "plural": false,
                                                                    "selections": (v13 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "CompensatoryTimeSetting",
                                                                    "kind": "LinkedField",
                                                                    "name": "timeStore",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v6 /*: any*/),
                                                                        (v8 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Event",
                                                                            "kind": "LinkedField",
                                                                            "name": "timeStoreEvent",
                                                                            "plural": false,
                                                                            "selections": (v14 /*: any*/),
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "CompensatoryTime",
                                                                    "kind": "LinkedField",
                                                                    "name": "times",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "description",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": (v9 /*: any*/),
                                                                            "concreteType": "TimeSpanUnitValue",
                                                                            "kind": "LinkedField",
                                                                            "name": "time",
                                                                            "plural": false,
                                                                            "selections": (v12 /*: any*/),
                                                                            "storageKey": "time(unit:\"HOUR\")"
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "TimeSpanUnitValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "totalTime",
                                                                    "plural": false,
                                                                    "selections": (v12 /*: any*/),
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "ISchedulableEntity",
                                            "abstractKey": "__isISchedulableEntity"
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "cursor",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "endCursor",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasNextPage",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": (v5 /*: any*/),
                    "filters": [
                        "model"
                    ],
                    "handle": "connection",
                    "key": "RunningSchedulesInformationByMonthQuery_schedulableEntities",
                    "kind": "LinkedHandle",
                    "name": "schedulableEntities"
                }
            ]
        },
        "params": {
            "cacheID": "71ad9795573d67c2d3de1e7c959886e8",
            "id": null,
            "metadata": {},
            "name": "RunningSchedulesInformationByMonth_fragmentQuery",
            "operationKind": "query",
            "text": "query RunningSchedulesInformationByMonth_fragmentQuery(\n  $after: String\n  $first: Int = 10\n  $model: SchedulableEntitiesQueryRequestInput\n  $month: DateTime!\n) {\n  ...RunningSchedulesInformationByMonth_fragment_314lgz\n}\n\nfragment RunningSchedulesInformationByMonthRow_fragment_3vjFD7 on ISchedulableEntity {\n  __isISchedulableEntity: __typename\n  id\n  name\n  color\n  scheduleTimesByMonth(month: $month) {\n    timeReport {\n      id\n    }\n    summary {\n      totalTime(unit: HOUR) {\n        value\n        unit\n      }\n      workedTime(unit: HOUR) {\n        value\n        unit\n      }\n      absenceTime(unit: HOUR) {\n        value\n        unit\n      }\n    }\n    employmentSummaries {\n      employment {\n        id\n        title\n      }\n      timeReportSummary {\n        expectedWorkTime(unit: HOUR) {\n          value\n          unit\n        }\n        eventSummaries {\n          event {\n            id\n            name\n          }\n          isWork\n          nonRegularPartsSummary {\n            event {\n              id\n              name\n            }\n            duration(unit: SECOND) {\n              value\n              unit\n            }\n          }\n          unit\n          value\n        }\n      }\n    }\n    compensatoryTimes {\n      employmentSetting {\n        id\n        title\n      }\n      timeStore {\n        id\n        name\n        timeStoreEvent {\n          id\n          name\n        }\n      }\n      times {\n        description\n        time(unit: HOUR) {\n          value\n          unit\n        }\n      }\n      totalTime {\n        value\n        unit\n      }\n    }\n  }\n}\n\nfragment RunningSchedulesInformationByMonth_fragment_314lgz on Query {\n  schedulableEntities(first: $first, after: $after, model: $model) {\n    edges {\n      node {\n        __typename\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n        ... on ISchedulableEntity {\n          __isISchedulableEntity: __typename\n          ...RunningSchedulesInformationByMonthRow_fragment_3vjFD7\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "e6f0035870910b9f9e797b55fe905915";
export default node;
